export default {
    isShow: false,
    data: '',
    getData: function() {
        return this.data;
    },
    setData: function(d) {
        this.data = d;
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/dialog.js